import React from "react";
import { m as motion } from "../../../shared/components/Motion";

/**
 * PublishButton Component
 * Renders publish button with state management
 */
const PublishButton = ({
  section,
  publishingState,
  onPublish,
  isLoading = false,
}) => {
  const isPublishing = publishingState[section.id] === true;
  const isPublished = publishingState[section.id] === "published";

  return (
    <button
      onClick={() => onPublish(section)}
      disabled={section.changes === 0 || isLoading}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.2rem",
        padding: "0.25rem 0.35rem",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: section.changes > 0 ? "white" : "rgba(0, 0, 0, 0.3)",
        border: "none",
        borderRadius: "2px",
        fontSize: "0.6rem",
        fontWeight: "600",
        cursor: section.changes > 0 && !isLoading ? "pointer" : "not-allowed",
        transition: "all 0.2s ease",
        position: "relative",
        opacity: isLoading ? 0.8 : 1,
        whiteSpace: "nowrap",
      }}
      onMouseEnter={(e) => {
        if (section.changes > 0 && !isLoading) {
          e.currentTarget.style.transform = "translateY(-1px)";
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {isPublishing ? (
        <>
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity }}
            style={{ display: "flex" }}
          >
            <i className="bx bx-loader" style={{ fontSize: "0.6rem" }}></i>
          </motion.div>
          <span>Publishing...</span>
        </>
      ) : isPublished ? (
        <>
          <i className="bx bx-check" style={{ fontSize: "0.6rem" }}></i>
          <span>Published</span>
        </>
      ) : (
        <>
          <i className="bx bx-rocket" style={{ fontSize: "0.6rem" }}></i>
          <span>Publish</span>
        </>
      )}
    </button>
  );
};

/**
 * DiscardButton Component
 * Renders discard button with state management
 */
const DiscardButton = ({
  section,
  discardingState,
  onDiscard,
  isLoading = false,
}) => {
  const isDiscarding = discardingState[section.id] === true;
  const isDiscarded = discardingState[section.id] === "discarded";

  return (
    <button
      onClick={() => onDiscard(section)}
      disabled={section.changes === 0 || isDiscarding}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.2rem",
        padding: "0.25rem 0.35rem",
        background: isDiscarded
          ? "#f97316"
          : section.changes > 0
          ? "#ef4444"
          : "rgba(0, 0, 0, 0.1)",
        color: section.changes > 0 ? "white" : "rgba(0, 0, 0, 0.3)",
        border: "none",
        borderRadius: "2px",
        fontSize: "0.6rem",
        fontWeight: "600",
        cursor:
          section.changes > 0 && !isDiscarding ? "pointer" : "not-allowed",
        transition: "all 0.2s ease",
        opacity: isDiscarding ? 0.8 : 1,
        whiteSpace: "nowrap",
      }}
      onMouseEnter={(e) => {
        if (section.changes > 0 && !isDiscarding) {
          e.currentTarget.style.transform = "translateY(-1px)";
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {isDiscarding ? (
        <>
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity }}
            style={{ display: "flex" }}
          >
            <i className="bx bx-loader" style={{ fontSize: "0.6rem" }}></i>
          </motion.div>
          <span>Discarding...</span>
        </>
      ) : isDiscarded ? (
        <>
          <i className="bx bx-check" style={{ fontSize: "0.6rem" }}></i>
          <span>Discarded</span>
        </>
      ) : (
        <>
          <i className="bx bx-trash" style={{ fontSize: "0.6rem" }}></i>
          <span>Discard</span>
        </>
      )}
    </button>
  );
};

export { PublishButton, DiscardButton };
